export default __webpack_public_path__ + "static/SR India - Safety Data Sheet - Caramel Color (Powders)-758445cb5a9e070b2a20ceea36cdf39f.pdf";